import { render, staticRenderFns } from "./BrowserHistory.vue?vue&type=template&id=d869beb2&scoped=true&"
import script from "./BrowserHistory.vue?vue&type=script&lang=js&"
export * from "./BrowserHistory.vue?vue&type=script&lang=js&"
import style0 from "./BrowserHistory.vue?vue&type=style&index=0&id=d869beb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d869beb2",
  null
  
)

export default component.exports